import * as React from 'react'

import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'
import { ExecutionElement } from '../flow/ExecutionElement'
import { ElementLabel } from './ElementLabel'

import type * as Flows from '../../../shared/domain/flows/types.no-deps'
import type { WithCachedImageUrl } from '../image/WithCachedImage'
import type { FileId } from '../../../shared/domain/files/types.no-deps'
import { fakeFetchUrl } from '../file/withS3Url'
import type { LoopPathIds } from '../../../shared/domain/flows/LoopPath.no-deps'
import { InspectableImage } from '../photo/InspectableImage'

interface Props {
    deps: CommonDeps
    elementId: Flows.ElementId
    loopPathIds: LoopPathIds
    label: string
    url: string
    annotationFileId?: FileId
    withCachedImageUrl: WithCachedImageUrl
    allowZoom: boolean
    openOptions?: () => void
}

export class ElementImageContent extends React.Component<Props, {}> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    private tryRender = () => {
        const { elementId, label, url, annotationFileId, openOptions } = this.props

        return (
            <ExecutionElement
                deps={this.props.deps}
                elementId={elementId}
                loopPathIds={this.props.loopPathIds}
                validationMessages={[]}
            >
                <ElementLabel required={false} label={label} validationMessages={[]} openOptions={openOptions} />

                <div className="AppCore__flow__ElementImageContent">
                    {this.props.withCachedImageUrl(url, (src) =>
                        this.props.withCachedImageUrl(fakeFetchUrl(annotationFileId, true), (annotation) =>
                            this.props.allowZoom ? (
                                <div className="AppCore__flow__ElementImageContent__image">
                                    <InspectableImage
                                        deps={this.props.deps}
                                        src={src}
                                        fullSizeSrc={url}
                                        annotation={annotationFileId != null ? annotation : null}
                                        title={label}
                                    />
                                </div>
                            ) : (
                                <zaptic-annotated-image
                                    class="AppCore__flow__ElementImageContent__image"
                                    src={src}
                                    annotation={annotationFileId != null ? annotation : null}
                                />
                            )
                        )
                    )}
                </div>
            </ExecutionElement>
        )
    }
}
